import React from 'react';

const EditIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.8461 5.06664L9.2936 12.6191C8.54152 13.3712 6.30899 13.7195 5.81024 13.2208C5.31149 12.722 5.65191 10.4895 6.40399 9.73743L13.9644 2.17703C14.1509 1.97362 14.3766 1.81011 14.628 1.69634C14.8794 1.58258 15.1512 1.52091 15.4271 1.5151C15.7029 1.5093 15.9772 1.55944 16.2331 1.66252C16.4891 1.76561 16.7215 1.91951 16.9163 2.11489C17.1112 2.31027 17.2644 2.5431 17.3668 2.79933C17.4691 3.05557 17.5186 3.32989 17.5121 3.60574C17.5055 3.8816 17.443 4.15329 17.3286 4.40437C17.2141 4.65544 17.05 4.88074 16.8461 5.06664Z"
      stroke="#313485"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.70801 3.16699H4.74967C3.90982 3.16699 3.10442 3.50062 2.51055 4.09448C1.91669 4.68835 1.58301 5.4938 1.58301 6.33366V14.2503C1.58301 15.0902 1.91669 15.8956 2.51055 16.4895C3.10442 17.0834 3.90982 17.417 4.74967 17.417H13.458C15.2076 17.417 15.833 15.992 15.833 14.2503V10.292"
      stroke="#313485"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EditIcon;
